<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-grid">
        <!-- Brand Section -->
        <div class="footer-column brand-column">
          <div class="footer-logo">
            <img src="/Images/Brewtopia Logo Dark Modenobg.png" alt="Brewtopia Cafe">
          </div>
          <p class="footer-tagline">Where Every Cup Tells a Story</p>
          <div class="social-links">
            <a href="https://www.tiktok.com" class="social-link" aria-label="TikTok" target="blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
	<path fill="currentColor" d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48" />
</svg>
            </a>
            <a href="https://www.instagram.com/tahx__?igsh=MWo4czR6MnR1Mjg3aA==" class="social-link" aria-label="Instagram" target="blank">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com" class="social-link" aria-label="Facebook" target="blank">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="footer-column">
          <h3 class="footer-title">Quick Links</h3>
          <ul class="footer-links">
            <li><a href="#">Home</a></li>
            <li><a href="#Menu">Menu</a></li>
            <li><a href="#About">About Us</a></li>
            <li><a href="#Contact">Contact</a></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-column">
          <h3 class="footer-title">Contact</h3>
          <ul class="footer-info">
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V7.4L12,12.2L5,7.4V5H19M19,19H5V9.6L12,14.4L19,9.6V19Z"/>
              </svg>
              <span>hello.launchpad.lagency@gmail.com</span>
            </li>
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"/>
              </svg>
              <span>+33 (×××) ×××-×××</span>
            </li>
            <li>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"/>
              </svg>
              <span>123 Coffee Street, Downtown</span>
            </li>
          </ul>
        </div>

        <!-- Newsletter -->
        <div class="footer-column newsletter-column">
          <h3 class="footer-title">Stay Updated</h3>
          <p class="newsletter-text">Subscribe to get special offers and updates</p>
          <form class="newsletter-form" @submit.prevent="handleNewsletter">
            <input 
              type="email" 
              v-model="emailInput"
              placeholder="E-Mail Address" 
              required
            >
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div class="footer-bottom">
        <p>&copy; 2025 Brewtopia. All rights reserved</p>
        <p>Designed And Created By <a href="https://tahx.netlify.app/" target="blank">Taha</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection',
  data() {
    return {
      emailInput: ''
    }
  },
  methods: {
    handleNewsletter() {
      console.log('Newsletter subscription:', this.emailInput);
      alert('Thank you for subscribing!');
      this.emailInput = '';
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #6F4E37;
  color: #FFF8DC;
  padding: 4rem 2rem 2rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
  gap: 3rem;
  margin-bottom: 3rem;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.brand-column {
  gap: 1rem;
}

.footer-logo {
  width: 160px;
  margin-bottom: 0;
}

.footer-logo img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.footer-tagline {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #FFF8DC;
  margin-bottom: 0.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  width: 36px;
  height: 36px;
  background-color: rgba(212, 166, 116, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF8DC;
  transition: all 0.3s ease;
}

.social-link:hover {
  background-color: #FFF8DC;
  color: #6F4E37;
  transform: translateY(-3px);
}

.footer-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  font-weight: 600;
  color: #FFF8DC;
  margin-bottom: 0.5rem;
}
a{
  text-decoration: underline;
  color: rgb(205, 164, 164);
  font-weight: 600;
  letter-spacing: 1px;
  font-family: playfair display, serif;
}
.footer-links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-links a {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #FFF8DC;
  font-weight: 300;
  text-decoration: none;
  transition: all 0.5s ease-in-out, padding-left 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: #FFF8DC;
  padding-left: 5px;
  color: #BDAF79;
}

.footer-info {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-info li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #FFF8DC;
}

.footer-info svg {
  flex-shrink: 0;
  opacity: 0.8;
}

.newsletter-text {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: #FFF8DC;
  line-height: 1.5;
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.newsletter-form input {
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
  border: 1.5px solid rgba(212, 166, 116, 0.3);
  border-radius: 8px;
  background-color: rgba(255, 248, 220, 0.05);
  color: #FFF8DC;
  transition: border-color 0.3s ease;
}

.newsletter-form input::placeholder {
  color: rgba(212, 166, 116, 0.6);
}

.newsletter-form input:focus {
  outline: none;
  border-color: #FFF8DC;
}

.newsletter-form button {
  padding: 0.75rem 1.5rem;
  background-color: #FFF8DC;
  color: #6F4E37;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.newsletter-form button:hover {
  background-color: #FFF8DC;
  transform: translateY(-2px);
}

.footer-bottom {
  padding-top: 2rem;
  border-top: 1px solid rgba(212, 166, 116, 0.2);
  text-align: center;
}

.footer-bottom p {
  font-family: 'Poppins', sans-serif;
  font-size: 0.85rem;
  color: #FFF8DC;
}

/* Responsive */
@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2.5rem;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 3rem 1.5rem 1.5rem;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }

  .footer-logo {
    width: 140px;
    margin-bottom: 0;
  }
}
</style>